import React from 'react';
import { Provider } from 'react-redux';
import store from "../../../store";
import BaseControl from "../common/BaseControl";
import { setActiveControl } from '../common/ControlBox';
import ReplayEGListWindow from './ReplayEGListWindow';

export default class ReplayEGListControl extends BaseControl {
    constructor(map, google) {
        super(map, google);
        this.controlBox = null;
        this.controlName = "travelledDistance";
        this.gpsPlayer = null;


        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    setGPSPlayer(gpsPlayer) {
        this.gpsPlayer = gpsPlayer;
        return this;
    }

    open() {
        if (!this.controlBox) this.controlBox = this.map.getControlBox(this.google.maps.ControlPosition.RIGHT_CENTER);
        if (this.controlBox.getControl(this.controlName)) return;

        this.controlBox.add({
            index: 1,
            name: this.controlName,
            className: "map-travelled-distance-container",
            component: <Provider store={store}>
                <div className="d-flex flex-column h-100">
                    <ReplayEGListWindow onClose={this.close} gpsPlayer={this.gpsPlayer} />
                </div>
            </Provider>
        });
        setActiveControl("ctlTravelledDistance", true);
    }

    close() {
        if (this.controlBox) this.controlBox.remove(this.controlName);
        setActiveControl("ctlTravelledDistance", false);
    }
}